import { useState, useMemo, useEffect } from 'react'
import s from './LaneHeader.scss'
import { NumericFormat } from 'react-number-format'
import { FaArrowRight, FaCheckSquare, FaInfoCircle } from 'react-icons/fa'
import { laneTotalValue } from 'utils/serializers'
import cn from 'classnames'
import { Tooltip } from 'reactstrap'
import { TooltipActions } from './TooltipActions'
import { FollowupModalContainer } from 'components/common/modals/FollowupModalContainer'
import { FollowupDateModal } from 'components/common/modals/FollowupDateModal'
import { getCurrency } from 'utils/authService'

const LaneHeader = ({
  id,
  title,
  subTitle,
  subtitleTooltip,
  cards,
  dataType,
  addBoardColumnRef,
  unfilteredCards,
  toggleSelectAllDeals,
  hasActions,
  boardHeaders,
  updateDealsStatusFollowupDate
}) => {
  const [showFollowupModal, setShowFollowupModal] = useState(false)
  const [showFollowupDateModal, setShowFollowupDateModal] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)
  const [isLaneSelected, setIsLaneSelected] = useState(false)

  const toggleFollowupModal = () => {
    setShowTooltip(false)
    setShowFollowupModal(showFollowupModal => !showFollowupModal)
  }

  const toggleFollowupDateModal = () => {
    setShowTooltip(false)
    setShowFollowupDateModal(showFollowupDateModal => !showFollowupDateModal)
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const selectedCards = useMemo(() => cards.filter(card => card.selected), [cards])

  useEffect(() => {
    setIsLaneSelected(selectedCards.length === cards.length)
  }, [selectedCards, cards])

  return (
    <div
      className={s.titleWrapper}
      ref={element => {
        addBoardColumnRef && addBoardColumnRef(element, id)
      }}
    >
      <p className={s.title}>{title}</p>
      {subTitle && (
        <p className={s.subTitle}>
          {subTitle}{' '}
          {subtitleTooltip && (
            <>
              <span id="subtitle-tooltip" className={cn(s.pullRight, s.subtitleInfo)}>
                <span>
                  <FaInfoCircle />
                </span>
              </span>
              <Tooltip
                placement="bottom"
                isOpen={showTooltip}
                target="subtitle-tooltip"
                toggle={() => setShowTooltip(showTooltip => !showTooltip)}
                innerClassName={s.subtitlePopover}
                className={s.tooltipWrapper}
              >
                <span>{subtitleTooltip}</span>
              </Tooltip>
            </>
          )}
        </p>
      )}
      <p className={cn(s.subTitle, s.pullLeft)}>
        <NumericFormat
          value={boardHeaders ? boardHeaders[id]?.value : laneTotalValue(unfilteredCards || cards)}
          displayType="text"
          thousandSeparator
          prefix={getCurrency().symbol}
          renderText={value => <span className={s.subTitle}>{value}</span>}
        />
        <FaArrowRight className={s.arrow} />
        {boardHeaders
          ? boardHeaders[id]?.count
          : unfilteredCards
            ? unfilteredCards.length
            : cards.length}{' '}
        {unfilteredCards
          ? unfilteredCards.length === 1
            ? dataType
            : `${dataType}s`
          : cards.length === 1
            ? dataType
            : `${dataType}s`}
      </p>
      {cards.length > 0 && hasActions && (
        <div className={cn(s.pullRight, s.actionsWrapper)}>
          <div id={`item-actions-${id}`} className={cn(s.pullRight, s.threePoints)}>
            ...
          </div>
          <Tooltip
            placement="bottom"
            isOpen={showTooltip}
            target={`item-actions-${id}`}
            toggle={() => setShowTooltip(showTooltip => !showTooltip)}
            trigger="click"
            innerClassName={s.popover}
            className={s.tooltipWrapper}
          >
            <TooltipActions
              laneId={id}
              cards={cards}
              toggleFollowupDateModal={toggleFollowupDateModal}
              toggleFollowupModal={toggleFollowupModal}
            />
          </Tooltip>
          <FaCheckSquare
            className={cn(s.pullRight, s.checkMark, {
              [s.selected]: isLaneSelected
            })}
            onClick={e => {
              toggleSelectAllDeals(e, id, isLaneSelected)
              setIsLaneSelected(!isLaneSelected)
            }}
          />
          {showFollowupModal && (
            <FollowupModalContainer
              showFollowupModal={showFollowupModal}
              toggleFollowupModal={toggleFollowupModal}
              selectedCards={selectedCards}
            />
          )}
          {showFollowupDateModal && (
            <FollowupDateModal
              showFollowupDateModal={showFollowupDateModal}
              toggleFollowupDateModal={toggleFollowupDateModal}
              entities={selectedCards}
              title="Opportunities"
              cancelCb={toggleFollowupDateModal}
              onSave={updateDealsStatusFollowupDate}
            />
          )}
        </div>
      )}
    </div>
  )
}

export default LaneHeader
